import React from 'react';
import { motion } from 'framer-motion';
import { SlideLayout } from '../SlideLayout';
import { Cpu, Server, Zap, Layers } from 'lucide-react';
export function LandscapeSlide() {
  const chips = [{
    name: 'GPU',
    color: 'text-chip-gpu',
    bg: 'bg-chip-gpu/10',
    border: 'border-chip-gpu/20',
    icon: Layers,
    desc: 'Dominant but power-hungry. General purpose parallel processing.',
    share: '36-47%'
  }, {
    name: 'ASIC',
    color: 'text-chip-asic',
    bg: 'bg-chip-asic/10',
    border: 'border-chip-asic/20',
    icon: Cpu,
    desc: 'Highly efficient but inflexible. Fixed function silicon.',
    share: '25%'
  }, {
    name: 'TPU',
    color: 'text-chip-tpu',
    bg: 'bg-chip-tpu/10',
    border: 'border-chip-tpu/20',
    icon: Server,
    desc: "Google's custom matrix math accelerator. Cloud-centric.",
    share: '~13%'
  }, {
    name: 'FPGA',
    color: 'text-chip-fpga',
    bg: 'bg-chip-fpga/10',
    border: 'border-chip-fpga/20',
    icon: Zap,
    desc: 'Reconfigurable, low latency, efficient. The adaptable choice.',
    share: 'Niche (Growing)'
  }];
  return <SlideLayout slideNumber={2} totalSlides={20} title="Market Overview" data-id="element-356">
      <div className="w-full h-full flex flex-col" data-id="element-357">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-5" data-id="element-358">
          <h2 className="text-4xl md:text-5xl font-bold mb-2" data-id="element-359">
            The AI Accelerator Landscape
          </h2>
          <p className="text-2xl text-brand-muted" data-id="element-360">
            A{' '}
            <span className="text-brand-primary font-mono font-bold" data-id="element-361">
              $600B+
            </span>{' '}
            market by 2033, currently fragmented across four key architectures.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 flex-1" data-id="element-362">
          {chips.map((chip, index) => <motion.div key={chip.name} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: index * 0.1 + 0.3
        }} className={`p-6 rounded-2xl border ${chip.border} ${chip.bg} flex items-center gap-5`} data-id="element-363">
              <div className={`p-3 rounded-lg bg-brand-dark ${chip.color} shrink-0`} data-id="element-364">
                <chip.icon size={40} data-id="element-365" />
              </div>
              <div className="flex-1" data-id="element-366">
                <div className="flex justify-between items-center mb-2" data-id="element-367">
                  <h3 className={`text-3xl font-bold ${chip.color}`} data-id="element-368">
                    {chip.name}
                  </h3>
                  <span className="font-mono text-lg bg-brand-dark px-3 py-1 rounded text-brand-muted" data-id="element-369">
                    {chip.share} Share
                  </span>
                </div>
                <p className="text-brand-muted text-xl leading-snug" data-id="element-370">
                  {chip.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1
      }} className="mt-3 text-center text-base text-brand-muted opacity-60" data-id="element-371">
          Source: Bloomberg Intelligence, Precedence Research [2][3]
        </motion.p>
      </div>
    </SlideLayout>;
}